// системные настройки парамтеров для отображения колонки данных
import { DictionaryType } from '@common/dictionaries';
import { SortDirection } from '../../table/constants/sort-direction';
import { JournalColumnType } from '../constants/journal-column-types';
export interface ColumnParams {
  label: string;
  dataProperty: string;
  uniqueId: string;
  width: number;
  maxWidth: number;
  orderIndex: number;
  type: JournalColumnType;
  sortDirection: SortDirection;
  sortOrder: number;
  sortable: boolean;
  editable?: boolean;
  flex?: number;
  // iconType: IconType;
  enumCode?: string | DictionaryType;
}
